var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickGreenFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(.833)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.167,
    cy: 14.811,
    r: 14.167,
    fill: "#01BF9B",
    stroke: "#01BF9B"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.5,
    d: "M6.439 14.811L11.591 19.962 21.894 9.659"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickGreenFilled);
export default __webpack_public_path__ + "static/media/tick-green-filled.e832a32071a458ca9a5c9fa241bc9b12.svg";
export { ForwardRef as ReactComponent };